export const SITE_URL = process.env.REACT_APP_BACKEND_URL;

export const CLINIC = {
  name: "Delhi STD Clinic",
  doctor: "Dr. Ankur Lal",
  title: "STD & Sexual Health Specialist | Dermatologist",
  credentialLine: "Ex-STD Specialist & Former Senior Resident, AIIMS New Delhi",
  medal: "Gold Medalist, MD Dermatology",
  phoneDisplay: "+91 95597 58479",
  phoneRaw: "+919559758479",
  whatsapp:
    "https://wa.me/919559758479?text=Hello%20Dr.%20Ankur%20Lal%2C%20I%20would%20like%20to%20book%20a%20confidential%20consultation.",
  email: "[clinic-email@example.com — to be updated]",
  address: "[Clinic address, New Delhi — to be updated]",
  timings: "[Clinic timings — to be updated. Consultations by appointment.]",
  fees: "₹900 per consultation — online or clinic",
  mapsUrl: "#",
  photo: "/images/dr-ankur-lal.webp",
};

export const CONSULT_TYPES = [
  { value: "online", label: "Online Consultation (Video / Phone)" },
  { value: "clinic", label: "Clinic Appointment (In-Person)" },
  { value: "hiv-pep", label: "Urgent HIV PEP Consultation" },
];

export const MARQUEE_ITEMS = [
  "Private & Confidential Care",
  "Ex-STD Specialist & Former Senior Resident, AIIMS New Delhi",
  "Gold Medalist, MD Dermatology",
  "Evidence-Based Treatment",
  "Online & Clinic Consultations",
  "Judgment-Free Environment",
];

export const WHY_CHOOSE = [
  {
    title: "AIIMS New Delhi Experience",
    desc: "Former STD Specialist and Senior Resident at AIIMS New Delhi, one of India's foremost medical institutes.",
  },
  {
    title: "Gold Medalist in MD Dermatology",
    desc: "Academic distinction in postgraduate dermatology training.",
  },
  {
    title: "STD & Sexual Health Expertise",
    desc: "Focused clinical experience in sexually transmitted infections and related sexual-health concerns.",
  },
  {
    title: "Confidential Care",
    desc: "Private, respectful and non-judgmental consultations — always.",
  },
  {
    title: "Online Consultation",
    desc: "Consult conveniently and discreetly from the privacy of your home.",
  },
  {
    title: "Evidence-Based Treatment",
    desc: "Diagnosis and treatment based on clinical assessment and established medical guidelines.",
  },
];

export const MANIFESTO = [
  {
    num: "01",
    title: "Private by Default",
    desc: "Every consultation is one-on-one with Dr. Ankur Lal. Your concerns are heard privately, respectfully and without interruption.",
  },
  {
    num: "02",
    title: "Discreet Communication",
    desc: "Appointment details are handled with care. We reach you only through the contact details you choose to share.",
  },
  {
    num: "03",
    title: "No Judgment, Ever",
    desc: "Sexual health is healthcare. Every patient — regardless of background, orientation or history — is treated with the same professionalism and dignity.",
  },
  {
    num: "04",
    title: "Responsible Records",
    desc: "Your medical information is handled responsibly and used only for your care. We never claim impossible secrecy — we practice genuine, professional confidentiality.",
  },
];

export const PRIVACY_POINTS = [
  "Confidential consultation",
  "Privacy-conscious patient care",
  "Professional medical environment",
  "Judgment-free communication",
  "Online consultation from home",
  "Secure appointment process",
];

export const JOURNEY = [
  { step: "1", label: "BOOK", desc: "Choose an online or clinic consultation." },
  { step: "2", label: "CONSULT", desc: "Discuss your concern privately with Dr. Ankur Lal." },
  { step: "3", label: "TEST", desc: "Get appropriate investigations when required." },
  { step: "4", label: "TREAT", desc: "Receive an individualized treatment plan." },
  { step: "5", label: "FOLLOW UP", desc: "Continue follow-up care where necessary." },
];

export const SYMPTOMS = [
  "Genital discharge",
  "Burning during urination",
  "Genital ulcers",
  "Genital sores",
  "Genital warts",
  "Genital itching",
  "Genital rash",
  "Genital lesions",
  "Testicular pain or swelling",
  "Pelvic pain",
  "Anal pain",
  "Anal discharge",
  "Pain during intercourse",
];

export const ONLINE_CONSULT_USES = [
  "STD/STI symptoms",
  "Sexual-health concerns",
  "HIV-related concerns",
  "HIV testing guidance",
  "HIV PEP consultation",
  "HIV PrEP consultation",
  "Test-result interpretation",
  "Syphilis follow-up",
  "Genital herpes follow-up",
  "Genital wart concerns",
  "Gonorrhea / chlamydia follow-up",
  "Molluscum contagiosum",
  "Vaginal discharge",
  "Vaginal warts",
  "HPV infection",
  "Treatment follow-up",
];

export const SERVICES = [
  {
    slug: "syphilis",
    name: "Syphilis",
    gridDesc:
      "Diagnosis with VDRL and TPHA blood tests, and treatment with Injection Benzathine Penicillin as per guidelines — with planned follow-up.",
    metaTitle: "Syphilis Treatment in Delhi | Dr. Ankur Lal — Delhi STD Clinic",
    metaDesc:
      "Confidential syphilis diagnosis (VDRL & TPHA blood tests) and treatment with Injection Benzathine Penicillin in Delhi by Dr. Ankur Lal, Ex-STD Specialist, AIIMS New Delhi.",
    h1: "Syphilis Treatment in Delhi",
    intro:
      "Syphilis is a bacterial sexually transmitted infection that can be effectively treated, especially when detected early. Because its symptoms can be subtle or easily missed, proper testing and medical assessment are important.",
    sections: [
      {
        heading: "How syphilis is diagnosed — VDRL & TPHA",
        body: "Diagnosis is made with blood tests — VDRL (a screening test) and TPHA (a confirmatory test) — along with clinical evaluation. The stage of infection — primary, secondary, latent or tertiary — guides treatment decisions and follow-up.",
      },
      {
        heading: "Treatment — Injection Benzathine Penicillin",
        body: "Syphilis is treated with Injection Benzathine Penicillin, given according to established medical guidelines. The dose and number of injections depend on the stage of infection and your clinical assessment. If you have a penicillin allergy, alternatives are discussed after evaluation.",
      },
      {
        heading: "Follow-up matters",
        body: "Follow-up blood tests (VDRL titres) at recommended intervals help confirm that treatment has been effective. Dr. Ankur Lal plans follow-up care individually for each patient.",
      },
    ],
    faqs: [
      {
        q: "Can syphilis be cured?",
        a: "Syphilis can usually be cured with appropriate antibiotic treatment, particularly when caught early. Follow-up testing is important to confirm the infection has cleared.",
      },
      {
        q: "Can syphilis occur without symptoms?",
        a: "Yes. Syphilis can be present without obvious symptoms (latent syphilis), which is why testing after a possible exposure can be important even if you feel well.",
      },
    ],
  },
  {
    slug: "genital-warts-hpv",
    name: "Genital Warts / HPV",
    gridDesc:
      "Diagnosis by clinical examination and biopsy where needed — treated with our customized immunotherapy protocol designed to clear warts externally and internally.",
    metaTitle: "Genital Warts & HPV Treatment in Delhi | Dr. Ankur Lal",
    metaDesc:
      "Genital wart (HPV) diagnosis by clinical examination and biopsy, with customized immunotherapy treatment designed to clear warts externally and internally — Dr. Ankur Lal, Delhi.",
    h1: "Genital Warts & HPV Treatment in Delhi",
    intro:
      "Genital warts are caused by certain types of the human papillomavirus (HPV). They are common, treatable, and nothing to be ashamed of. As a dermatologist, Dr. Ankur Lal is experienced in the assessment and treatment of genital warts.",
    sections: [
      {
        heading: "Diagnosis — clinical examination and biopsy",
        body: "Genital warts are usually diagnosed by careful clinical examination. Where the diagnosis needs confirmation or a lesion appears atypical, a biopsy may be recommended.",
      },
      {
        heading: "Treatment — customized immunotherapy",
        body: "Our focus is a customized immunotherapy treatment protocol designed to clear warts externally and internally — addressing both the visible lesions and the underlying viral activity. Where appropriate, lesion-directed options such as cryotherapy, electrosurgical procedures or topical treatments may also be used as part of your plan.",
        points: ["Customized immunotherapy protocol", "Cryotherapy", "Electrosurgical procedures", "Topical / chemical treatments"],
      },
      {
        heading: "What to expect",
        body: "Warts may require more than one session, and recurrence can happen because HPV can persist in the skin. Your treatment plan is individualized, and follow-up helps manage recurrences early.",
      },
    ],
    faqs: [
      {
        q: "Can genital warts be treated?",
        a: "Yes. Visible warts can be removed with treatments such as cryotherapy or electrosurgical procedures. Recurrence is possible, so follow-up is sometimes needed.",
      },
      {
        q: "Do genital warts mean I have cancer?",
        a: "The HPV types that usually cause visible genital warts are generally different from the high-risk types linked to cancer. A doctor can assess your individual situation and advise whether any additional screening is appropriate.",
      },
    ],
  },
  {
    slug: "gonorrhea",
    name: "Gonorrhea",
    gridDesc:
      "Diagnosis, appropriate testing and guideline-based treatment for gonorrhea — discreet and straightforward.",
    metaTitle: "Gonorrhea Treatment in Delhi | Confidential — Dr. Ankur Lal",
    metaDesc:
      "Confidential gonorrhea testing and guideline-based treatment in Delhi by Dr. Ankur Lal, STD & Sexual Health Specialist at Delhi STD Clinic.",
    h1: "Gonorrhea Treatment in Delhi",
    intro:
      "Gonorrhea is a common bacterial STI that is treatable with appropriate antibiotics. Because it can occur without symptoms, testing after a possible exposure is often advisable.",
    sections: [
      {
        heading: "Symptoms and silent infection",
        body: "Gonorrhea may cause discharge, burning during urination, or testicular, pelvic, anal or throat symptoms — but it can also cause no symptoms at all, particularly at certain sites.",
      },
      {
        heading: "Testing",
        body: "Testing is guided by the type of exposure and the anatomical sites involved. Site-appropriate sampling improves accuracy.",
      },
      {
        heading: "Treatment",
        body: "Treatment follows current medical guidelines. Because antibiotic resistance is a growing concern, correct treatment — and sometimes a test of cure — matters. Partner management is also discussed.",
      },
    ],
    faqs: [
      {
        q: "Can gonorrhea be cured?",
        a: "Yes, gonorrhea is curable with the correct antibiotic treatment. Following the prescribed regimen and any recommended follow-up testing is important.",
      },
      {
        q: "Can gonorrhea come back?",
        a: "Reinfection can occur if a partner is untreated or through new exposure. Partner treatment and safe-sex guidance reduce this risk.",
      },
    ],
  },
  {
    slug: "chlamydia",
    name: "Chlamydia",
    gridDesc:
      "Diagnosis, testing and appropriate antibiotic treatment for one of the most common — and most silent — STIs.",
    metaTitle: "Chlamydia Treatment in Delhi | Confidential Testing — Dr. Ankur Lal",
    metaDesc:
      "Confidential chlamydia testing and antibiotic treatment in Delhi by Dr. Ankur Lal at Delhi STD Clinic. Online and clinic consultations available.",
    h1: "Chlamydia Treatment in Delhi",
    intro:
      "Chlamydia is one of the most common sexually transmitted infections — and frequently causes no symptoms. The good news: it is easily tested for and curable with appropriate antibiotics.",
    sections: [
      {
        heading: "A frequently silent infection",
        body: "Many people with chlamydia have no symptoms. When symptoms occur, they may include discharge, burning during urination, pelvic pain or testicular pain.",
      },
      {
        heading: "Testing",
        body: "Chlamydia is diagnosed with simple laboratory tests, usually on urine or site-appropriate swabs, depending on the exposure.",
      },
      {
        heading: "Treatment and follow-up",
        body: "Appropriate antibiotic treatment cures chlamydia in most cases. Abstinence during treatment and partner management help prevent reinfection.",
      },
    ],
    faqs: [
      {
        q: "Can chlamydia be cured?",
        a: "Yes. Chlamydia is curable with appropriate antibiotics. Follow-up advice — including partner treatment — helps prevent reinfection.",
      },
      {
        q: "What happens if chlamydia is untreated?",
        a: "Untreated chlamydia can lead to complications such as pelvic inflammatory disease or epididymitis. Testing and timely treatment prevent most complications.",
      },
    ],
  },
  {
    slug: "molluscum-contagiosum",
    name: "Molluscum Contagiosum",
    gridDesc:
      "Diagnosis and advanced international-brand laser treatment — in most cases, a single laser session is sufficient to clear molluscum.",
    metaTitle: "Molluscum Contagiosum Laser Treatment in Delhi | Dr. Ankur Lal",
    metaDesc:
      "Molluscum contagiosum treatment in Delhi with advanced international-brand laser — in most cases a single session is sufficient. By dermatologist Dr. Ankur Lal at Delhi STD Clinic.",
    h1: "Molluscum Contagiosum Treatment in Delhi",
    intro:
      "Molluscum contagiosum is a common viral skin infection that causes small, smooth, dome-shaped bumps. In adults, genital involvement is often sexually acquired. It is benign and manageable.",
    sections: [
      {
        heading: "Diagnosis",
        body: "Diagnosis is usually made by clinical examination — molluscum lesions have a characteristic appearance that an experienced dermatologist recognizes readily.",
      },
      {
        heading: "Treatment — advanced laser, usually one session",
        body: "We use an advanced international-brand laser for molluscum removal. In most cases, a single laser session is sufficient to clear the lesions, with minimal discomfort and quick recovery. The exact plan is confirmed after clinical examination.",
      },
      {
        heading: "Reducing spread",
        body: "Avoiding scratching and skin-to-skin contact over affected areas helps limit spread to yourself and partners until lesions clear.",
      },
    ],
    faqs: [
      {
        q: "Is molluscum contagiosum dangerous?",
        a: "No. It is a benign skin infection. Treatment is usually about comfort, appearance and reducing transmission.",
      },
      {
        q: "Will it go away on its own?",
        a: "It often resolves spontaneously over several months, but genital lesions are commonly treated to speed clearance and reduce spread.",
      },
    ],
  },
  {
    slug: "genital-herpes",
    name: "Genital Herpes",
    gridDesc:
      "Diagnosis and management of genital HSV — first episodes, recurrences and suppressive therapy when appropriate.",
    metaTitle: "Genital Herpes Treatment in Delhi | Dr. Ankur Lal — Delhi STD Clinic",
    metaDesc:
      "Confidential genital herpes (HSV) diagnosis and management in Delhi — first-episode treatment, recurrence care and suppressive therapy by Dr. Ankur Lal.",
    h1: "Genital Herpes Treatment in Delhi",
    intro:
      "Genital herpes is a very common viral infection caused by herpes simplex virus (HSV). While it cannot be eliminated from the body, it can be managed effectively — and most people with herpes live entirely normal lives.",
    sections: [
      {
        heading: "Diagnosis",
        body: "Diagnosis is based on clinical examination and, where appropriate, laboratory testing of lesions or blood tests. Many people with HSV have mild or unrecognized symptoms.",
      },
      {
        heading: "Treatment of episodes",
        body: "Antiviral medication shortens and eases first episodes and recurrences, especially when started early.",
      },
      {
        heading: "Suppressive therapy",
        body: "For frequent recurrences, daily suppressive antiviral therapy can reduce outbreaks and lower the risk of transmission to partners. Whether this is appropriate for you is decided together during consultation.",
      },
    ],
    faqs: [
      {
        q: "Can genital herpes be treated?",
        a: "Yes. While HSV stays in the body, antiviral treatment effectively controls outbreaks, and suppressive therapy is an option for frequent recurrences.",
      },
      {
        q: "Can I have a normal relationship with herpes?",
        a: "Yes. With open communication, appropriate treatment and simple precautions, most people with herpes maintain healthy relationships and sex lives.",
      },
    ],
  },
  {
    slug: "chancroid",
    name: "Chancroid",
    gridDesc:
      "Diagnosis of painful genital ulcers caused by Haemophilus ducreyi, with guideline-based antibiotic treatment.",
    metaTitle: "Chancroid Treatment in Delhi | Dr. Ankur Lal — Delhi STD Clinic",
    metaDesc:
      "Confidential chancroid diagnosis and antibiotic treatment in Delhi by Dr. Ankur Lal, STD & Sexual Health Specialist at Delhi STD Clinic.",
    h1: "Chancroid Treatment in Delhi",
    intro:
      "Chancroid is a bacterial STI that causes painful genital ulcers, sometimes with swollen groin lymph nodes. It is treatable with appropriate antibiotics — early diagnosis matters.",
    sections: [
      {
        heading: "How chancroid is diagnosed",
        body: "Diagnosis begins with clinical examination of the ulcers. Because several conditions can cause genital ulcers, tests are usually done to rule out syphilis and herpes, and to guide the right treatment.",
      },
      {
        heading: "Treatment",
        body: "Chancroid is treated with appropriate antibiotics according to established guidelines. Ulcers typically begin improving within days of starting treatment. Follow-up confirms complete healing.",
      },
      {
        heading: "Partners and prevention",
        body: "Recent sexual partners should also be assessed. HIV testing is generally recommended for anyone diagnosed with chancroid.",
      },
    ],
    faqs: [
      {
        q: "Can chancroid be cured?",
        a: "Yes. Chancroid is curable with appropriate antibiotic treatment. Follow-up ensures the ulcers have healed completely.",
      },
      {
        q: "How is chancroid different from herpes?",
        a: "Both can cause painful genital ulcers, but they are different infections with different treatments. Clinical evaluation and testing distinguish between them.",
      },
    ],
  },
  {
    slug: "lgv",
    name: "LGV (Lymphogranuloma Venereum)",
    gridDesc:
      "Diagnosis and treatment of LGV — a chlamydia-related STI that can cause ulcers and swollen lymph nodes.",
    metaTitle: "LGV (Lymphogranuloma Venereum) Treatment in Delhi | Dr. Ankur Lal",
    metaDesc:
      "Confidential LGV diagnosis and treatment in Delhi by Dr. Ankur Lal, STD & Sexual Health Specialist at Delhi STD Clinic.",
    h1: "LGV Treatment in Delhi",
    intro:
      "Lymphogranuloma venereum (LGV) is an STI caused by specific strains of chlamydia. It may begin with a small, often unnoticed lesion and progress to swollen, tender lymph nodes in the groin, or rectal symptoms.",
    sections: [
      {
        heading: "How LGV is diagnosed",
        body: "Diagnosis involves clinical evaluation and specific laboratory testing for the chlamydia strains that cause LGV, using samples from the affected site.",
      },
      {
        heading: "Treatment",
        body: "LGV is treated with a longer course of antibiotics than uncomplicated chlamydia, as per established guidelines. Completing the full course is essential.",
      },
      {
        heading: "Why early care matters",
        body: "Without treatment, LGV can lead to complications such as chronic swelling or scarring. Early specialist assessment prevents most complications.",
      },
    ],
    faqs: [
      {
        q: "Can LGV be cured?",
        a: "Yes. LGV is curable with the correct antibiotic course. Completing the full course and attending follow-up are important.",
      },
      {
        q: "What symptoms does LGV cause?",
        a: "It may start with a small painless lesion, followed by swollen and tender groin lymph nodes, or rectal pain and discharge depending on the site of infection.",
      },
    ],
  },
  {
    slug: "genital-ulcer-disease",
    name: "Genital Ulcer Disease (GUD)",
    gridDesc:
      "Specialist evaluation of genital ulcers and sores — identifying the exact cause before treatment.",
    metaTitle: "Genital Ulcer Disease (GUD) Evaluation in Delhi | Dr. Ankur Lal",
    metaDesc:
      "Confidential evaluation of genital ulcers and sores in Delhi — accurate diagnosis of syphilis, herpes, chancroid and LGV by Dr. Ankur Lal at Delhi STD Clinic.",
    h1: "Genital Ulcer Disease (GUD) Evaluation in Delhi",
    intro:
      "A genital ulcer or sore can have several causes — syphilis, genital herpes, chancroid, LGV or non-infectious conditions. Guessing wrong wastes time; correct diagnosis guides correct treatment.",
    sections: [
      {
        heading: "Why evaluation matters",
        body: "Different causes of genital ulcers can look similar. Treatment that works for one cause may not work for another — which is why specialist assessment and the right tests come first.",
      },
      {
        heading: "How the cause is identified",
        body: "Evaluation includes clinical examination and, where appropriate, tests such as VDRL and TPHA for syphilis, and Tzanck smear or PCR for herpes — chosen based on your assessment.",
      },
      {
        heading: "Treatment",
        body: "Treatment is cause-specific and guideline-based, with follow-up to confirm healing. Partner assessment is discussed where relevant.",
      },
    ],
    faqs: [
      {
        q: "Do painful and painless ulcers mean different things?",
        a: "They can point toward different causes — for example, syphilis ulcers are typically painless while herpes ulcers are usually painful — but appearance alone is not enough. Testing confirms the cause.",
      },
      {
        q: "Can a genital ulcer heal on its own?",
        a: "Some ulcers heal temporarily on their own, but the underlying infection may remain and progress. Medical assessment is important even if an ulcer seems to be improving.",
      },
    ],
  },
  {
    slug: "urethral-discharge",
    name: "Urethral Discharge",
    gridDesc:
      "Evaluation of urethral discharge with Gram stain and PCR testing, and guideline-based treatment.",
    metaTitle: "Urethral Discharge Treatment in Delhi | Dr. Ankur Lal — Delhi STD Clinic",
    metaDesc:
      "Confidential evaluation of urethral discharge in Delhi — Gram stain and PCR testing for gonorrhea and chlamydia, with guideline-based treatment by Dr. Ankur Lal.",
    h1: "Urethral Discharge Treatment in Delhi",
    intro:
      "Urethral discharge — with or without burning during urination — is most commonly caused by treatable infections such as gonorrhea or chlamydia. Prompt testing leads to prompt, correct treatment.",
    sections: [
      {
        heading: "How discharge is evaluated",
        body: "Assessment includes your symptoms and exposure history, examination, and laboratory testing — typically Gram stain and PCR testing on a swab or urine sample for gonorrhea and chlamydia.",
      },
      {
        heading: "Treatment",
        body: "Treatment follows current guidelines and depends on the organisms identified. Partner management and abstinence during treatment help prevent reinfection.",
      },
      {
        heading: "When to seek care urgently",
        body: "Seek care promptly if discharge is accompanied by testicular pain or swelling, fever, or severe discomfort.",
      },
    ],
    faqs: [
      {
        q: "Does urethral discharge always mean an STI?",
        a: "Not always, but infection is the most common cause and should be ruled out with testing. Evaluation gives you a clear answer.",
      },
      {
        q: "Can urethral discharge go away without treatment?",
        a: "Symptoms may settle temporarily, but the infection can persist and cause complications or spread to partners. Testing and treatment are recommended.",
      },
    ],
  },
  {
    slug: "vaginal-discharge",
    name: "Vaginal Discharge",
    gridDesc:
      "Specialist evaluation of abnormal vaginal discharge — testing for the exact cause and cause-specific treatment.",
    metaTitle: "Vaginal Discharge Treatment in Delhi | Dr. Ankur Lal — Delhi STD Clinic",
    metaDesc:
      "Confidential evaluation and treatment of abnormal vaginal discharge in Delhi — testing for vaginal infections and STIs, with cause-specific treatment by Dr. Ankur Lal.",
    h1: "Vaginal Discharge Treatment in Delhi",
    intro:
      "A change in vaginal discharge — in colour, amount, consistency or smell — is one of the most common sexual-health concerns. Most causes are easily diagnosed and treated once the exact cause is identified.",
    sections: [
      {
        heading: "Common causes",
        body: "Abnormal discharge may be caused by vaginal infections such as bacterial vaginosis or candidiasis, or by sexually transmitted infections such as trichomoniasis, chlamydia or gonorrhea. Each has a different treatment — which is why proper evaluation matters more than guesswork.",
      },
      {
        heading: "How it is evaluated",
        body: "Assessment includes your symptoms and history, examination where appropriate, and simple swab-based tests to identify the cause. Testing is discreet and chosen based on your specific situation.",
      },
      {
        heading: "Treatment",
        body: "Treatment is cause-specific and guideline-based — most causes clear with a short course of the right medication. Where an STI is involved, partner assessment and follow-up are discussed.",
      },
    ],
    faqs: [
      {
        q: "Is vaginal discharge always an infection?",
        a: "No. Some discharge is normal and varies through the menstrual cycle. A change in colour, amount, consistency or smell — especially with itching, burning or pain — deserves medical evaluation.",
      },
      {
        q: "Should I use over-the-counter remedies first?",
        a: "Self-treatment without a diagnosis often treats the wrong cause and delays recovery. A short evaluation identifies the exact cause so the right treatment works the first time.",
      },
    ],
  },
  {
    slug: "vaginal-warts",
    name: "Vaginal Warts",
    gridDesc:
      "Diagnosis by clinical examination and biopsy where needed — treated with our customized immunotherapy protocol designed to clear warts externally and internally.",
    metaTitle: "Vaginal Warts Treatment in Delhi | Dr. Ankur Lal — Delhi STD Clinic",
    metaDesc:
      "Confidential vaginal wart (HPV) diagnosis and treatment in Delhi — customized immunotherapy protocol designed to clear warts externally and internally, by Dr. Ankur Lal.",
    h1: "Vaginal Warts Treatment in Delhi",
    intro:
      "Vaginal and vulval warts are caused by certain types of the human papillomavirus (HPV). They are common, treatable, and nothing to be ashamed of — specialist care clears them safely and discreetly.",
    sections: [
      {
        heading: "Diagnosis — clinical examination and biopsy",
        body: "Vaginal warts are usually diagnosed by careful clinical examination. Where the diagnosis needs confirmation or a lesion appears atypical, a biopsy may be recommended.",
      },
      {
        heading: "Treatment — customized immunotherapy",
        body: "Our focus is a customized immunotherapy treatment protocol designed to clear warts externally and internally — addressing both the visible lesions and the underlying viral activity. Where appropriate, lesion-directed options may also be used as part of your plan.",
        points: ["Customized immunotherapy protocol", "Lesion-directed treatments where appropriate", "Individualized follow-up plan"],
      },
      {
        heading: "What to expect",
        body: "Warts may require more than one session, and recurrence can happen because HPV can persist in the skin. Your treatment plan is individualized, and follow-up helps manage recurrences early.",
      },
    ],
    faqs: [
      {
        q: "Can vaginal warts be treated?",
        a: "Yes. Visible warts can be cleared with treatment, including our customized immunotherapy protocol. Recurrence is possible, so follow-up may be recommended.",
      },
      {
        q: "Do vaginal warts mean I have cancer?",
        a: "The HPV types that usually cause visible warts are generally different from the high-risk types linked to cancer. A doctor can assess your individual situation and advise whether any additional screening is appropriate.",
      },
    ],
  },
];

export const FAQS = [
  {
    q: "Is STD consultation confidential?",
    a: "Yes. Consultations with Dr. Ankur Lal are private and handled with strict professional confidentiality. Your information is used only for your care and never shared without your consent, except where the law requires.",
  },
  {
    q: "Can I consult Dr. Ankur Lal online?",
    a: "Yes. Online video and phone consultations are available for most sexual-health concerns, including symptoms, test-result interpretation, HIV PEP/PrEP guidance and follow-ups.",
  },
  {
    q: "Can I get HIV PEP consultation online?",
    a: "Yes — and you should not delay. An online consultation allows rapid assessment of your exposure and guidance on whether PEP is indicated and where to start it immediately.",
  },
  {
    q: "How quickly should I seek HIV PEP?",
    a: "As soon as possible after a potential exposure. PEP is most effective when started early and is generally not recommended after 72 hours. If you think you may need PEP, seek medical advice now rather than waiting.",
  },
  {
    q: "What happens during an STD consultation?",
    a: "Dr. Ankur Lal will ask about your symptoms, concerns and relevant history in a respectful, non-judgmental way. Examination or tests are suggested only when clinically appropriate, and a treatment or testing plan is explained clearly.",
  },
  {
    q: "Can an STI occur without symptoms?",
    a: "Yes. Many STIs — including chlamydia, gonorrhea, syphilis and HIV — can cause few or no symptoms. Testing may be important even if you feel completely well.",
  },
  {
    q: "When should I test after sexual exposure?",
    a: "It depends on the infection and the test. Some infections are detectable within days, while others take weeks. A consultation helps you choose the right tests at the right time, avoiding both false reassurance and unnecessary repeat testing.",
  },
  {
    q: "Can syphilis be cured?",
    a: "Yes. Syphilis is usually curable with appropriate antibiotic treatment, especially when detected early. Follow-up blood tests confirm that treatment has worked.",
  },
  {
    q: "Can genital warts be treated?",
    a: "Yes. Visible warts can be removed with clinic treatments such as cryotherapy or electrosurgical procedures. Recurrence is possible, so follow-up may be recommended.",
  },
  {
    q: "Can genital herpes be treated?",
    a: "Yes. While herpes stays in the body, antiviral medicines effectively control outbreaks, and daily suppressive therapy can reduce recurrences and transmission risk.",
  },
  {
    q: "Can gonorrhea be cured?",
    a: "Yes, with the correct guideline-based antibiotic treatment. Partner management and, in some cases, follow-up testing are important to prevent reinfection.",
  },
  {
    q: "Can chlamydia be cured?",
    a: "Yes. Chlamydia is curable with appropriate antibiotics. Partners should also be assessed to prevent reinfection.",
  },
  {
    q: "What tests may be needed after unprotected sex?",
    a: "Depending on the exposure and timing, testing may include HIV, syphilis, gonorrhea, chlamydia, hepatitis B and hepatitis C. The right panel is individual — a consultation ensures you test for what matters, at the right time, without unnecessary tests.",
  },
  {
    q: "Can I consult without feeling embarrassed?",
    a: "Yes. Sexual health is a routine part of medical care. Dr. Ankur Lal consults on these concerns every day, and every patient is treated with professionalism and without judgment.",
  },
  {
    q: "Do I need an appointment?",
    a: "Yes, consultations are by appointment so that every patient gets unhurried, private time. Booking online takes less than a minute.",
  },
  {
    q: "Is online follow-up available?",
    a: "Yes. Follow-up consultations — including reviewing test results and treatment response — can usually be done online, from wherever you are.",
  },
];

export const clinicJsonLd = {
  "@context": "https://schema.org",
  "@type": "MedicalClinic",
  name: "Delhi STD Clinic",
  medicalSpecialty: ["Dermatology", "InfectiousDisease"],
  telephone: "+919559758479",
  url: SITE_URL,
  address: {
    "@type": "PostalAddress",
    addressLocality: "New Delhi",
    addressCountry: "IN",
  },
};

export const physicianJsonLd = {
  "@context": "https://schema.org",
  "@type": "Physician",
  name: "Dr. Ankur Lal",
  medicalSpecialty: "Dermatology",
  description:
    "STD & Sexual Health Specialist | Dermatologist. Ex-STD Specialist & Former Senior Resident, AIIMS New Delhi. Gold Medalist, MD Dermatology.",
  worksFor: { "@type": "MedicalClinic", name: "Delhi STD Clinic" },
  telephone: "+919559758479",
};

export const faqJsonLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: FAQS.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};
